/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PropertyManagementGetHouseEntranceCoordinatesQueryVariables = {|
  companyId: string,
  startRow?: ?number,
  endRow?: ?number,
|};
export type PropertyManagementGetHouseEntranceCoordinatesQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +HouseEntrances: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +address: ?{|
          +street: string,
          +number: string,
          +zip: string,
          +city: string,
        |},
        +coordinates: ?{|
          +lat: number,
          +lng: number,
        |},
        +countUsageUnits: number,
      |}>
    |}
  |}
|};
export type PropertyManagementGetHouseEntranceCoordinatesQuery = {|
  variables: PropertyManagementGetHouseEntranceCoordinatesQueryVariables,
  response: PropertyManagementGetHouseEntranceCoordinatesQueryResponse,
|};
*/


/*
query PropertyManagementGetHouseEntranceCoordinatesQuery(
  $companyId: ID!
  $startRow: Int
  $endRow: Int
) {
  Me {
    Company(id: $companyId) {
      HouseEntrances(options: {startRow: $startRow, endRow: $endRow}) {
        id
        tableId
        address {
          street
          number
          zip
          city
        }
        coordinates {
          lat
          lng
        }
        countUsageUnits
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endRow"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startRow"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "endRow",
          "variableName": "endRow"
        },
        {
          "kind": "Variable",
          "name": "startRow",
          "variableName": "startRow"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "concreteType": "HouseEntrance",
  "kind": "LinkedField",
  "name": "HouseEntrances",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "street",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zip",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Coordinates",
      "kind": "LinkedField",
      "name": "coordinates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lng",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countUsageUnits",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyManagementGetHouseEntranceCoordinatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PropertyManagementGetHouseEntranceCoordinatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d01b11009814c5ed4a8708b84e350da9",
    "id": null,
    "metadata": {},
    "name": "PropertyManagementGetHouseEntranceCoordinatesQuery",
    "operationKind": "query",
    "text": "query PropertyManagementGetHouseEntranceCoordinatesQuery(\n  $companyId: ID!\n  $startRow: Int\n  $endRow: Int\n) {\n  Me {\n    Company(id: $companyId) {\n      HouseEntrances(options: {startRow: $startRow, endRow: $endRow}) {\n        id\n        tableId\n        address {\n          street\n          number\n          zip\n          city\n        }\n        coordinates {\n          lat\n          lng\n        }\n        countUsageUnits\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dc6bfef9b91b8ed9b96eac51476b712c';

module.exports = node;
